import { Box } from '@mui/material';
import {
  ProfileDetailSection,
  ProfileHeaderSection,
  StyledActivityCardBackground
} from 'modules';
import React from 'react';



export type ProfileActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const ProfileActivity = (props: ProfileActivityProps) => {

  return (
    <StyledActivityCardBackground.FC>
      <Box
        height='calc(100vh - 10rem)'
        display='flex'
        flexDirection='row'
        justifyContent='stretch'
        columnGap='1rem'
      >

        <ProfileDetailSection.FC />
        <ProfileHeaderSection.FC />
      </Box>
    </StyledActivityCardBackground.FC>
  );
};
